// @flow

import * as React from "react";
import { Form } from "react-final-form";

import { FormRow, FieldControl, TextInput, Button, validators, errors } from "buba-components";
import { isFormSubmitting } from "buba-components/src/utils/helpers";
import { requestFile } from "../../api/actions";
import { DESCRIPTION } from "./formFields";

import styles from "./RequestFile.scss";

type RequestFileProps = {
  inquiryProcessId: number,
  onError: number => void,
  refetchFiles: () => Promise<any>
};

const RequestFile = ({ inquiryProcessId, onError, refetchFiles }: RequestFileProps) => (
  <Form
    onSubmit={values =>
      requestFile({ id: inquiryProcessId, ...values })
        .then(() => refetchFiles())
        .catch(error => {
          onError(error.response && error.response.status);
          window.Rollbar.critical("Error while post request", error);
        })
    }
    render={({ form, handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <header>Weitere Unterlagen von der Bürgschaftsbank anfordern</header>
        <FormRow>
          <FieldControl
            name={DESCRIPTION}
            validate={validators.combineValidators(
              validators.required(errors.requiredField()),
              validators.maxLength(100, errors.maxLengthCharacters(100))
            )}
            additionalInfo="Bitte geben Sie einen aussagekräftigen Dokumentennamen an, um dieses Dokument von der Bürgschaftsbank anzufordern.
Hinweis: Es kann sich dabei auch um Dokumente vom Kunden handeln. Die Bürgschaftsbank übernimmt die Anforderung für Sie."
          >
            {({ input, meta }) => (
              <div className={styles.documentsRequest}>
                <div className={styles.documentsRequestInput}>
                  <TextInput input={input} meta={meta} placeholder="Dokumentennamen eintippen" />
                </div>
                <div>
                  <Button
                    size="small"
                    onClick={() => {
                      const formSubmit = form.submit();
                      if (formSubmit) {
                        formSubmit.then(form.restart);
                      }
                    }}
                    isDisabled={form.getState().invalid || isFormSubmitting(form)}
                  >
                    Jetzt anfordern
                  </Button>
                </div>
              </div>
            )}
          </FieldControl>
        </FormRow>
      </form>
    )}
  />
);

export default RequestFile;
